// hooks/useAuthCheck.ts
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../Api/Login';
import { useAuthStore } from '../../store/store';


export function useAuthCheck() {
  const setAuthenticated = useAuthStore((state) => state.setAuthenticated);
  const setLoading = useAuthStore((state) => state.setLoading);
  const setAdmin = useAuthStore((state) => state.setAdmin);

  const { data, isPending, isError } = useQuery({
    queryKey: ['check-auth'],
    queryFn: () => apiRequest('get', '/auth/is-authenticated'),
    retry: false,
    refetchOnWindowFocus: true,
    staleTime: 1000 * 60 * 5, 
  });

  useEffect(() => {
    setLoading(isPending);
    if (data?.authenticated) {
      setAuthenticated(true);
      setAdmin(data?.admin)
    } else if (isError) {
      setAuthenticated(false);
    }
  }, [data, isPending, isError, setAuthenticated, setAdmin, setLoading]);
}
